module.exports = __webpack_public_path__ + "static/media/SV4.560259d5.jpg";